import moment from "moment";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMyDataStore } from "src/store/me/me.store";
import { useAdmsStore } from "src/store/users/adms.store";
import { AdmsListTypeItem } from "src/types/users";

export const useAdms = () => {
  const { isLoadingAdmsList, admsList, getAdmsList, deleteAdms } = useAdmsStore();
  const [selectedIds, setSelectedIds] = useState<string[]>([])
  const [formattedAdmList, setFormattedAdmList] = useState<AdmsListTypeItem[]>([])
  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.usersAdm)
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const TABLEHEADER = [
    { id: 'name', label: 'Nome' },
    { id: 'email', label: 'E-mail' },
    { id: 'createdAtFormatted', label: 'Data de Criação' },
    { id: 'updatedAtFormatted', label: 'Ultima atualização' },
  ];

  useEffect(() => {
    getAdmsList();
  }, []);

  const onSelectRow = (id: string) => {
    const selectedIndex = selectedIds.indexOf(id);

    let newSelected: string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedIds, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedIds.slice(1));
    } else if (selectedIndex === selectedIds.length - 1) {
      newSelected = newSelected.concat(selectedIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedIds.slice(0, selectedIndex),
        selectedIds.slice(selectedIndex + 1)
      );
    }
    setSelectedIds(newSelected);
  };

  const onSelectAllRows = (newSelecteds: string[]) => {
    setSelectedIds(newSelecteds)
  };

  const handleDeleteUsers = async () => {
    deleteAdms(selectedIds)
    getAdmsList();
    enqueueSnackbar('Usuário(s) deletado(s) com sucesso!')
  }

  useEffect(() => {
    setFormattedAdmList(admsList.map(adm => ({
      ...adm,
      createdAtFormatted: moment(adm.createdAt).format('DD/MM/YYYY'),
      updatedAtFormatted: moment(adm.updatedAt).format('DD/MM/YYYY'),
    })));
  }, [admsList])


  return {
    TABLEHEADER,
    isLoadingAdmsList,
    formattedAdmList,
    permissions,
    onSelectRow,
    onSelectAllRows,
    handleDeleteUsers,
    navigate
  };
};
